import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'

import { MatButtonModule } from '@angular/material/button'
import { escapeKey$ } from '../../services'
import { TranslatePipe } from '@ngx-translate/core'

export enum ReportDialogType {
  message = 'message',
  warning = 'warning',
  error = 'error',
}

export interface ReportDialogData {
  reportDialogType: ReportDialogType
  title?: string
  action: string
  messages: string[]
  buttonLabel?: string
  afterClose?: () => void
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, MatDialogModule, MatButtonModule],
})
export class ReportDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<ReportDialogComponent>>(MatDialogRef)
  data = inject<ReportDialogData>(MAT_DIALOG_DATA)

  ReportDialogType = ReportDialogType

  constructor() {
    escapeKey$(this.dialogRef).subscribe(() => this.dialogRef.close())
  }

  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe(() => {
      if (this.data.afterClose) {
        this.data.afterClose()
      }
    })
    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Enter') {
        this.cancel()
      }
    })
  }

  cancel() {
    this.dialogRef.close()
  }
}
